import React from 'react';

export default function Img({ src, alt, style, loading = 'lazy', fetchpriority }) {
  const isAsset = src && src.startsWith('/assets/');
  if (!isAsset) return <img src={src} alt={alt} style={style} loading={loading} />;

  const webp = src.replace(/\.(jpeg|jpg)$/i, '.webp');
  return (
    <picture>
      <source srcSet={webp} type="image/webp" />
      <img src={src} alt={alt} style={style} loading={loading} fetchpriority={fetchpriority} />
    </picture>
  );
}
